import { ComunicacaoBox } from './styles'
import { Tooltip } from '@material-ui/core'
import { isNullReturnHyphen, DateFormat } from "../../../functions"
import ReciboAceite from "../../../pages/MinhasComunicacoes/ReciboAceite"
import ReciboResposta from "../../../pages/MinhasComunicacoes/ReciboResposta"
import { useState } from 'react'
import { useSnackbar } from "notistack"
import { CircularProgress } from '@material-ui/core'
import ComunicacaoControleService from "../../../services/ComunicacaoControleService"
import { AttachFile, Check, Chat, Warning, Folder } from '@material-ui/icons'
import Arquivos from '../../../pages/MinhasComunicacoes/Arquivos'
import EnumAcoesComunicacao from '../../../enums/enumAcoesComunicacao'
import enumEtapasComunicacao from '../../../enums/enumEtapasComunicacao'
import webconfig from '../../../webconfig.json'

export default function Comunicacao({
    idOrgaoJurisdicionado,
    comunicacao,
    etapaComunicacao,
    setRecarregarComunicacoes }) {

    const [recibo, setRecibo] = useState({
        open: false,
        controle: {}
    });

    const [reciboResposta, setReciboResposta] = useState({
        open: false,
        controle: {}
    })

    const [arquivos, setArquivos] = useState({
        open: false,
        arquivos: [],
        respostas: []
    });

    const [loading, setLoading] = useState(false)
    const [loadingProcesso, setLoadingProcesso] = useState(false)
    const { enqueueSnackbar } = useSnackbar()

    const CriaRecibo = () => {
        setLoading(true)
        ComunicacaoControleService.DaAceite(comunicacao)
            .then(response => {
                setLoading(false)
                if (response.status === 200) {
                    let conteudoReciboBase64 = null;
                    if (response.data.arquivos.filter((item) => { return item.tipoArquivo === 2 }).length > 0) {
                        conteudoReciboBase64 = response.data.arquivos.filter((item) => { return item.tipoArquivo === 2 })[0].conteudoBase64
                    }

                    let reciboModal = {
                        open: true,
                        controle: response.data,
                        conteudoReciboBase64: conteudoReciboBase64
                    }

                    setRecibo(reciboModal)
                }
                else {
                    enqueueSnackbar('Não foi possível gerar o Recibo de Aceite. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const abreModalReciboResposta = () => {

        let reciboRespostaModal = {
            open: true,
            controle: comunicacao
        }

        setReciboResposta(reciboRespostaModal);
    }

    const AbreDocumentosComunicacao = (aplica) => {
        setArquivos({
            open: true,
            arquivos: comunicacao.arquivos,
            respostas: comunicacao.respostas,
            ultimaResposta: comunicacao.ultimaResposta,
            aplicaScroll: aplica
        })
    }

    return (
        <>
            <ReciboAceite
                idOrgaoJurisdicionado={idOrgaoJurisdicionado}
                recibo={recibo}
                setRecibo={setRecibo}
                setRecarregarComunicacoes={setRecarregarComunicacoes}
            />

            <ReciboResposta
                idOrgaoJurisdicionado={idOrgaoJurisdicionado}
                reciboResposta={reciboResposta}
                setReciboResposta={setReciboResposta}
                setRecarregarComunicacoes={setRecarregarComunicacoes}
            />

            <Arquivos
                arquivos={arquivos}
                setArquivos={setArquivos}
            />

            <ComunicacaoBox.Desktop id="ComunicacaoBox" >
                <ComunicacaoBox.Content>
                    <ComunicacaoBox.Acao>

                        {comunicacao.acoes &&
                            comunicacao.acoes.map((acao) => (

                                (acao === EnumAcoesComunicacao.Aceitar &&
                                    (
                                        <Tooltip title="Aceite" placement="top">
                                            <ComunicacaoBox.BotaoAcao
                                                className="bg-hover--ui-color-10 border--ui-color-10 color--ui-color-10 color-hover--ui-white"
                                                disabled={loadingProcesso}
                                                onClick={CriaRecibo}
                                                title='Aceite'
                                            >
                                                {
                                                    loading
                                                        ?
                                                        <CircularProgress
                                                            size={22}
                                                            style={{
                                                                color: '#ffffff'
                                                            }} />
                                                        : <Check />
                                                }
                                            </ComunicacaoBox.BotaoAcao>
                                        </Tooltip>
                                    )) ||

                                (acao === EnumAcoesComunicacao.EnviarResposta &&
                                    (
                                        <Tooltip title="Responder" placement="top">
                                            <ComunicacaoBox.BotaoAcao
                                                className="bg-hover--ui-color-10 border--ui-color-10 color--ui-color-10 color-hover--ui-white"
                                                disabled={loadingProcesso}
                                                onClick={abreModalReciboResposta}
                                                title='Responder'
                                            >
                                                {
                                                    loading
                                                        ?
                                                        <CircularProgress
                                                            size={22}
                                                            style={{
                                                                color: '#ffffff'
                                                            }} />
                                                        : <Chat />
                                                }
                                            </ComunicacaoBox.BotaoAcao>
                                        </Tooltip>
                                    )) ||

                                (acao === EnumAcoesComunicacao.Responder &&
                                    (
                                        <Tooltip title="Responder" placement="top">
                                            <ComunicacaoBox.BotaoAcao
                                                className="bg-hover--ui-color-10 border--ui-color-10 color--ui-color-10 color-hover--ui-white"
                                                disabled={loadingProcesso}
                                                onClick={abreModalReciboResposta}
                                                title='Responder'
                                            >
                                                {
                                                    loading
                                                        ?
                                                        <CircularProgress
                                                            size={22}
                                                            style={{
                                                                color: '#ffffff'
                                                            }} />
                                                        : <Chat />
                                                }
                                            </ComunicacaoBox.BotaoAcao>
                                        </Tooltip>
                                    ))
                            ))}

                        {Boolean(etapaComunicacao &&
                            // Se estiver pendente de ciência, o arquivo não pode ser visualizado.
                            (etapaComunicacao === enumEtapasComunicacao.PendenteResposta ||
                                etapaComunicacao === enumEtapasComunicacao.PendenteTriagem ||
                                etapaComunicacao === enumEtapasComunicacao.PendenteLiberacao ||
                                etapaComunicacao === enumEtapasComunicacao.RespondidaEncerrada)) &&
                            (
                                <Tooltip title="Visualizar comunicação, seus anexos e respostas" placement="top">
                                    <ComunicacaoBox.BotaoAcao
                                        className="bg-hover--ui-color-10 border--ui-color-10 color--ui-color-10 color-hover--ui-white"
                                        disabled={loadingProcesso}
                                        onClick={() => AbreDocumentosComunicacao(false)}
                                        title='Visualizar comunicação, seus anexos e respostas'
                                    >
                                        {
                                            loading
                                                ?
                                                <CircularProgress
                                                    size={22}
                                                    style={{
                                                        color: '#ffffff'
                                                    }} />
                                                : <Folder />
                                        }
                                    </ComunicacaoBox.BotaoAcao>
                                </Tooltip>
                            )
                        }
                    </ComunicacaoBox.Acao>

                    <ComunicacaoBox.Documento>
                        <ComunicacaoBox.Informacao>
                            <span title="Documento Comunicacao">Comunicação</span>
                            {comunicacao.dataAceite != null ? (
                                <ComunicacaoBox.InformacaoNumeroDocumento
                                    className="txt-oficio"
                                    title="Visualizar comunicação, seus anexos e respostas"
                                    onClick={() => AbreDocumentosComunicacao(false)}
                                >
                                    <ComunicacaoBox.NumeroDocumento>{isNullReturnHyphen(comunicacao.tipoDocumento) + " nº " + isNullReturnHyphen(comunicacao.numeroDocumentoNaOrigem)}</ComunicacaoBox.NumeroDocumento>

                                    {comunicacao.arquivos.filter((item) => { return item.tipoArquivo === 1; }).length > 0 && (
                                        <ComunicacaoBox.Anexos>
                                            <ComunicacaoBox.NumeroAnexos>{comunicacao.arquivos.filter((item) => { return item.tipoArquivo === 1; }).length}</ComunicacaoBox.NumeroAnexos>
                                            <ComunicacaoBox.IconInformacao color='black'>
                                                <AttachFile />
                                            </ComunicacaoBox.IconInformacao>
                                        </ComunicacaoBox.Anexos>
                                    )}

                                </ComunicacaoBox.InformacaoNumeroDocumento>
                            )
                                : (
                                    <ComunicacaoBox.InformacaoNumeroDocumentoSemLink
                                        className="txt-oficio"
                                        title={isNullReturnHyphen(comunicacao.tipoDocumento) + " nº " + isNullReturnHyphen(comunicacao.numeroDocumentoNaOrigem)}
                                    >
                                        <ComunicacaoBox.DadoComunicacao>{isNullReturnHyphen(comunicacao.tipoDocumento) + " nº " + isNullReturnHyphen(comunicacao.numeroDocumentoNaOrigem)}</ComunicacaoBox.DadoComunicacao>

                                        {comunicacao.arquivos.filter((item) => { return item.tipoArquivo === 1; }).length > 0 && (
                                            <ComunicacaoBox.Anexos>
                                                <ComunicacaoBox.NumeroAnexos>{comunicacao.arquivos.filter((item) => { return item.tipoArquivo === 1; }).length}</ComunicacaoBox.NumeroAnexos>
                                                <ComunicacaoBox.IconInformacao color='black'>
                                                    <AttachFile />
                                                </ComunicacaoBox.IconInformacao>
                                            </ComunicacaoBox.Anexos>

                                        )}

                                    </ComunicacaoBox.InformacaoNumeroDocumentoSemLink>
                                )}

                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Órgão Jurisdicionado Destinatário">Destinatário</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(comunicacao.nomeOrgaoJurisdicionado)}>{isNullReturnHyphen(comunicacao.nomeOrgaoJurisdicionado)}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Pessoa Responsável do Órgão Jurisdicionado">Responsável</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(comunicacao.nomePessoaResponsavel)}>{isNullReturnHyphen(comunicacao.nomePessoaResponsavel)}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Número do Processo">Processo</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(comunicacao.numeroDoProcesso)}>{isNullReturnHyphen(comunicacao.numeroDoProcesso)}</ComunicacaoBox.DadoComunicacao>
                            {/* {comunicacao.numeroDoProcesso !== null ? (
                                <ComunicacaoBox.Processo
                                    className="txt-oficio"
                                    title={isNullReturnHyphen(comunicacao.numeroDoProcesso)}                                    
                                >
                                    {isNullReturnHyphen(comunicacao.numeroDoProcesso)}
                                </ComunicacaoBox.Processo>
                            )
                                :
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(comunicacao.numeroDoProcesso)}>{isNullReturnHyphen(comunicacao.numeroDoProcesso)}</ComunicacaoBox.DadoComunicacao>
                            } */}
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Assunto Processual">Assunto do Processo</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(comunicacao.assuntoProcessual)}>{isNullReturnHyphen(comunicacao.assuntoProcessual)}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Unidade do TCE-GO que emitiu a comunicação">Unidade Emitente</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(comunicacao.nomeUnidadeEmitente)}>{isNullReturnHyphen(comunicacao.nomeUnidadeEmitente)}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        <ComunicacaoBox.Informacao>
                            <span title="Data de envio da comunicação ao Jurisdicionado">Data de Envio</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(DateFormat(comunicacao.dataEnvioComunicacao))}>{isNullReturnHyphen(DateFormat(comunicacao.dataEnvioComunicacao))}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        {comunicacao.dataAceite && (
                            <ComunicacaoBox.Informacao>
                                <span title="Data do aceite pelo Jurisdicionado da comunicação do TCE-GO">Data do Aceite</span>
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(DateFormat(comunicacao.dataAceite))}>{isNullReturnHyphen(DateFormat(comunicacao.dataAceite))}</ComunicacaoBox.DadoComunicacao>
                            </ComunicacaoBox.Informacao>
                        )}

                        <ComunicacaoBox.Informacao>
                            <span title="Exige resposta">Exige Resposta?</span>
                            <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={comunicacao.exigeResposta === 1 ? 'Sim' : 'Não'}>{comunicacao.exigeResposta === 1 ? 'Sim' : 'Não'}</ComunicacaoBox.DadoComunicacao>
                        </ComunicacaoBox.Informacao>

                        {comunicacao.dataVencimentoPrazo && (
                            <ComunicacaoBox.Informacao>
                                <span title="Data do vencimento">Data do Vencimento</span>
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(DateFormat(comunicacao.dataVencimentoPrazo))}>{isNullReturnHyphen(DateFormat(comunicacao.dataVencimentoPrazo))}</ComunicacaoBox.DadoComunicacao>
                            </ComunicacaoBox.Informacao>
                        )}

                        {comunicacao.dataEnvioUltimaResposta && (
                            <ComunicacaoBox.Informacao>
                                <span title="Data do Envio da Resposta/Outros">Data Envio Última Resposta/Outros</span>
                                {comunicacao.ultimaResposta != null &&
                                    comunicacao.ultimaResposta.situacao !== 3
                                    ? (
                                        <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(DateFormat(comunicacao.dataEnvioUltimaResposta))}>{isNullReturnHyphen(DateFormat(comunicacao.dataEnvioUltimaResposta))}</ComunicacaoBox.DadoComunicacao>
                                    )
                                    :
                                    (
                                        <ComunicacaoBox.DadoComunicacao
                                            className="txt-oficio"
                                            title={isNullReturnHyphen(DateFormat(comunicacao.dataEnvioUltimaResposta))}
                                            onClick={() => AbreDocumentosComunicacao(true)}
                                            style={{ color: "orange", cursor: "pointer" }}
                                        >
                                            <div style={{ display: 'inline' }}>
                                                {isNullReturnHyphen(DateFormat(comunicacao.dataEnvioUltimaResposta))}
                                            </div>
                                            <div style={{ display: 'inline' }}>
                                                <ComunicacaoBox.IconInformacao color='orange'>
                                                    <Warning />
                                                </ComunicacaoBox.IconInformacao>
                                            </div>

                                        </ComunicacaoBox.DadoComunicacao>
                                    )}
                            </ComunicacaoBox.Informacao>
                        )}

                        {comunicacao.motivoDeliberacaoUltimaResposta && (
                            <ComunicacaoBox.Informacao>
                                <span title="Motivo Deliberação">Motivo Deliberação</span>
                                <ComunicacaoBox.DadoComunicacao className="txt-oficio" title={isNullReturnHyphen(comunicacao.motivoDeliberacaoUltimaResposta)}>{isNullReturnHyphen(comunicacao.motivoDeliberacaoUltimaResposta)}</ComunicacaoBox.DadoComunicacao>
                            </ComunicacaoBox.Informacao>
                        )}

                    </ComunicacaoBox.Documento>
                </ComunicacaoBox.Content>

            </ComunicacaoBox.Desktop>
        </>
    )
}